import languageManager from './languageManager';
export const localizedImage = {
    mounted(el: any, binding: any) {
        // console.error('src 拦截: 指令开始执行');
        applyLocalization(el, binding);

        // // 标记是否已经处理过，防止重复处理
        // if (el._localizedProcessed) {
        //     const originalSrc = binding.value || el.getAttribute('src');
        //     console.error('src 拦截: 该图片已处理过：', originalSrc);
        //     return;
        // }
        // el._localizedProcessed = true;

        // const updateImageSrc = () => {
        //     const originalSrc = binding.value || el.getAttribute('src');
        //     if (!originalSrc) return;
        //     const currentLocale = languageManager.getCurrentLocale(true);
        //     if (currentLocale == 'pt-br' as any) {
        //         return;
        //     }
        //     // 检查是否已经是本地化路径，避免重复处理
        //     if (isAlreadyLocalized(originalSrc)) {
        //         console.error('src 拦截: 该图片已处理过：', originalSrc);
        //         return;
        //     }

        //     const localizedSrc = generateLocalizedImagePath(originalSrc, currentLocale);
        //     console.error(`src 拦截 图片路径转换: ${originalSrc} -> ${localizedSrc}`);
        //     el.src = localizedSrc;
        // };

        // // 初始设置
        // updateImageSrc();

        // // 保存原始路径，用于后续比较
        // el._originalSrc = binding.value || el.getAttribute('src');

        // // 定期检查语言变化
        // // const intervalId = setInterval(() => {
        // //     updateImageSrc();
        // // }, 2000);
        // // el._unwatchLocalizedImage = () => {
        // //     clearInterval(intervalId);
        // // };
    },

    updated(el: any, binding: any) {
        // 检查原始路径是否发生变化
        const currentOriginalSrc = binding.value || el.getAttribute('src');
        if (currentOriginalSrc !== el._originalSrc) {
            console.error('src 拦截: 图片原始路径发生变化，重新处理');
            el._originalSrc = currentOriginalSrc;
            el._localizedProcessed = false; // 重置标记
            // this.mounted(el, binding);
            applyLocalization(el, binding);
        }
    },

    unmounted(el: any) {
        el._unwatchLocalizedImage?.();
        // 清理自定义属性
        delete el._localizedProcessed;
        delete el._originalSrc;
    },
};

function applyLocalization(el: any, binding: any) {
    // 标记是否已经处理过，防止重复处理
    if (el._localizedProcessed) {
        return;
    }
    el._localizedProcessed = true;

    const updateImageSrc = () => {
        const originalSrc = binding.value || el.getAttribute('src');
        if (!originalSrc) return;

        const currentLocale = languageManager.getCurrentLocale(true);

        if (currentLocale === ('pt-br' as any)) {
            return;
        }

        if (isAlreadyLocalized(originalSrc)) {
            return;
        }

        const localizedSrc = generateLocalizedImagePath(originalSrc, currentLocale);
        el.src = localizedSrc;
    };

    updateImageSrc();

    el._originalSrc = binding.value || el.getAttribute('src');
}

// 检查路径是否已经是本地化路径
function isAlreadyLocalized(path: string): boolean {
    const supportedLocales = ['my-mm'];

    // 检查是否包含任何支持的语言后缀
    return supportedLocales.some(locale => {
        const suffix = `_${locale.replace('-', '_')}`;
        return path.includes(suffix);
    });
}

// 生成本地化图片路径
function generateLocalizedImagePath(originalPath: string, currentLocale: string): string {
    // 支持的语言列表
    const supportedLocales = ['my-mm', 'en-ph'];
    // console.error(
    //     'src 拦截 对比',
    //     currentLocale,
    //     supportedLocales,
    //     supportedLocales.includes(currentLocale)
    // );

    // 如果当前语言不是支持的语言或者是默认语言，使用原图
    if (!supportedLocales.includes(currentLocale)) {
        return originalPath;
    }
    // 替换路径：@/assets/img/agencom/0036_yuce_bai.webp → @/assets/img/agencom/0036_yuce_bai_pt.webp
    // return originalPath.replace(/(\.[^/.]+)$/, `_${currentLocale.replace('-', '_')}$1`);
    let destStr = originalPath.replace(/(\.[^/.]+)$/, `_${currentLocale}$1`);
    console.error('src替换', originalPath, destStr);
    return destStr;
}
